<template>
  <div class="emded-player">

    <div class = "previewing">
      <previewer id = "previewer" :project = "project" :scaled = "true"></previewer>
    </div>

    <editor-simple class = "editor2"></editor-simple>
  </div>
</template>

<script>
import EditorSimple from '../Editor/EditorSimple'
import Previewer from '../Previewer/Previewer'

export default {
  name: 'Embed',
  components: {
    EditorSimple,
    Previewer
  },
  props: {
    // projectId: String
  },
  watch: {
  },
  data () {
    return {
      projectId: null,
      autoPlay: false,
      toolbar: false,
      currentProject: { id: -1 }
    }
  },
  computed: {
    project () {
      return this.$store.state.project
    }
  },
  methods: {
    playProject: function (p) {
      if (this.playlistHead >= this.galleryItems.results.length) this.playlistHead = 0
      this.currentProject = this.galleryItems.results[this.playlistHead]
      this.playlistHead++
      console.log(this.currentProject.id)
      this.openProject(this.currentProject)
    }
  },
  created () {
    console.log('qq')
    console.log(this.$route.query.projectId)
    this.projectId = this.$route.query.projectId
    this.autoPlay = this.$route.query.autoplay
    this.toolbar = this.$route.query.toolbar
    this.$store.dispatch('fetchProject', this.projectId)
  },
  destroyed () {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.project-player {
  background: #ccc;
  display: grid;
  grid-template-columns: 250px auto;
  height: 100vh;
}

.previewing {
  position: absolute;
  top: 82px;
  left: 22px;
  z-index: 12;
  box-shadow: 0px 0px 12px 2px black;
}

.editor2 {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.debug2 {
  position: absolute;
  z-index: 12;

  p {
    background: white;
    padding: 12px;
    margin: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Embed/Embed.vue